import produce from 'immer';

export const initialState = ({
  learnosityRequestStudentScoringResults,
  learnosityRequestTeacherScoringResults,
  learnosityRequestResultsByRubric,
  learnosityRequestResults,
  learnosityRequestResultsByItem,
}) => ({
  results: [],
  resultsByItem: [],
  resultsByRubric: [],
  responseAnalysis: [],
  scoringRubricResponseAnalysis: [],
  studentScoringResults: [],
  teacherScoringResults: [],
  isReadyResults: !learnosityRequestResults,
  isReadyResultsByItem: !learnosityRequestResultsByItem,
  isReadyResultsByRubric: !learnosityRequestResultsByRubric,
  isReadyResponseAnalysis: true,
  isReadyScoringRubricResponseAnalysis: true,
  isReadyStudentScoringResults: !learnosityRequestStudentScoringResults,
  isReadyTeacherScoringResults: !learnosityRequestTeacherScoringResults,
});

export const ACTIONS = {
  onLearnosityDataResultsReady: 'ON_LEARNOSITY_DATA_READY',
  onLearnosityDataResultsByItemReady:
    'ON_LEARNOSITY_DATA_RESULTS_BY_ITEM_READY',
  onLearnosityDataResultsByRubricReady:
    'ON_LEARNOSITY_DATA_RESULTS_BY_RUBRIC_READY',
  onLearnosityDataResponseAnalysisReady:
    'ON_LEARNOSITY_DATA_RESPONSE_ANALYSIS_READY',
  onLearnosityDataScoringRubricResponseAnalysisReady:
    'ON_LEARNOSITY_DATA_SCORING_RUBRIC_RESPONSE_ANALYSIS_READY',
  onLearnosityDataStudentScoringResultsReady:
    'ON_LEARNOSITY_DATA_STUDENT_SCORING_RESULTS_READY',
  onLearnosityDataTeacherScoringResultsReady:
    'ON_LEARNOSITY_DATA_TEACHER_SCORING_RESULTS_READY',
};

/*eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["draft"] }]*/

export const reducer = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.onLearnosityDataResultsReady:
      draft.results = action.payload;
      draft.isReadyResults = true;
      return;

    case ACTIONS.onLearnosityDataResultsByItemReady:
      draft.resultsByItem = action.payload;
      draft.isReadyResultsByItem = true;
      return;

    case ACTIONS.onLearnosityDataResultsByRubricReady:
      draft.resultsByRubric = action.payload;
      draft.isReadyResultsByRubric = true;
      return;

    case ACTIONS.onLearnosityDataResponseAnalysisReady:
      draft.responseAnalysis = action.payload;
      draft.isReadyResponseAnalysis = true;
      return;

    case ACTIONS.onLearnosityDataScoringRubricResponseAnalysisReady:
      draft.scoringRubricResponseAnalysis = action.payload;
      draft.isReadyScoringRubricResponseAnalysis = true;
      return;

    case ACTIONS.onLearnosityDataStudentScoringResultsReady:
      draft.studentScoringResults = action.payload;
      draft.isReadyStudentScoringResults = true;
      return;

    case ACTIONS.onLearnosityDataTeacherScoringResultsReady:
      draft.teacherScoringResults = action.payload;
      draft.isReadyTeacherScoringResults = true;
      return;

    default:
      throw Error('action type is not supported');
  }
});
